export default function isCamelCase(error: string) {
    // Check if the string starts with a lowercase letter and contains at least one uppercase letter
    return (value: string) => {
        if (!/^[a-z][a-zA-Z]*$/.test(value)) {
            return error;
        }
        return undefined;
    };
}
